import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { changePassword } from '../../services/api';
import '../../styles/Admin.css';

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    
    if (message.text) {
      setMessage({ type: '', text: '' });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // التحقق
    if (!formData.currentPassword || !formData.newPassword || !formData.confirmPassword) {
      setMessage({ type: 'error', text: 'يرجى ملء جميع الحقول' });
      return;
    }

    if (formData.newPassword.length < 6) {
      setMessage({ type: 'error', text: 'يجب أن تكون كلمة المرور الجديدة 6 أحرف على الأقل' });
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setMessage({ type: 'error', text: 'كلمات المرور الجديدة غير متطابقة' });
      return;
    }

    if (formData.currentPassword === formData.newPassword) {
      setMessage({ type: 'error', text: 'يجب أن تكون كلمة المرور الجديدة مختلفة عن الحالية' });
      return;
    }

    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      await changePassword({
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword
      });

      setMessage({ 
        type: 'success', 
        text: 'تم تغيير كلمة المرور بنجاح! جاري إعادة توجيهك لتسجيل الدخول...' 
      });

      // مسح النموذج
      setFormData({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      });

      // تسجيل الخروج والتوجيه لصفحة الدخول بعد ثانيتين
      setTimeout(() => {
        localStorage.removeItem('token');
        navigate('/admin/login');
      }, 2000);

    } catch (error) {
      console.error('Change Password Error:', error);
      const errorMsg = error.response?.data?.message || 'فشل في تغيير كلمة المرور';
      setMessage({ type: 'error', text: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/admin/login');
  };

  return (
    <div className="admin-layout" dir="rtl">
      {/* Mobile Menu Button */}
      <button 
        className={`mobile-menu-btn ${sidebarOpen ? 'active' : ''}`}
        onClick={() => setSidebarOpen(!sidebarOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Sidebar Overlay */}
      <div 
        className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`}
        onClick={() => setSidebarOpen(false)}
      />

      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="admin-sidebar-header">
          <h2 className="admin-sidebar-logo">لوحة التحكم</h2>
          <p className="admin-sidebar-subtitle">إدارة المعرض</p>
        </div>

        <nav>
          <ul className="admin-nav">
            <li className="admin-nav-item">
              <Link to="/admin/dashboard" className="admin-nav-link" onClick={() => setSidebarOpen(false)}>
                <span className="nav-icon">📊</span>
                <span>الرئيسية</span>
              </Link>
            </li>
            <li className="admin-nav-item">
              <Link to="/admin/hero" className="admin-nav-link" onClick={() => setSidebarOpen(false)}>
                <span className="nav-icon">🎯</span>
                <span>القسم الرئيسي</span>
              </Link>
            </li>
            <li className="admin-nav-item">
              <Link to="/admin/about" className="admin-nav-link" onClick={() => setSidebarOpen(false)}>
                <span className="nav-icon">👤</span>
                <span>نبذة عني</span>
              </Link>
            </li>
            <li className="admin-nav-item">
              <Link to="/admin/projects" className="admin-nav-link" onClick={() => setSidebarOpen(false)}>
                <span className="nav-icon">🏗️</span>
                <span>المشاريع</span>
              </Link>
            </li>
            <li className="admin-nav-item">
              <Link to="/admin/contact" className="admin-nav-link" onClick={() => setSidebarOpen(false)}>
                <span className="nav-icon">📧</span>
                <span>معلومات التواصل</span>
              </Link>
            </li>
            <li className="admin-nav-item">
              <Link to="/admin/change-password" className="admin-nav-link active" onClick={() => setSidebarOpen(false)}>
                <span className="nav-icon">🔒</span>
                <span>تغيير كلمة المرور</span>
              </Link>
            </li>
            <li className="admin-nav-item">
              <a href="/" className="admin-nav-link" target="_blank" rel="noopener noreferrer">
                <span className="nav-icon">🌐</span>
                <span>عرض الموقع</span>
              </a>
            </li>
          </ul>
        </nav>

        <div className="admin-sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <span>🚪</span>
            تسجيل الخروج
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="admin-main">
        <div className="admin-header">
          <h1>تغيير كلمة المرور</h1>
          <p>تحديث كلمة مرور حسابك للأمان</p>
        </div>

        <div className="admin-content" style={{ maxWidth: '600px' }}>
          {message.text && (
            <div className={`alert alert-${message.type}`}>
              {message.text}
            </div>
          )}

          <div className="password-notice">
            <div className="notice-icon">⚠️</div>
            <div>
              <strong>تنبيه أمني:</strong>
              <p>بعد تغيير كلمة المرور، سيتم تسجيل خروجك وستحتاج لتسجيل الدخول مجدداً بكلمة المرور الجديدة.</p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="admin-form">
            {/* Current Password */}
            <div className="form-group">
              <label htmlFor="currentPassword">
                كلمة المرور الحالية *
                <span className="field-hint">أدخل كلمة المرور الحالية</span>
              </label>
              <input
                type="password"
                id="currentPassword"
                name="currentPassword"
                value={formData.currentPassword}
                onChange={handleChange}
                placeholder="أدخل كلمة المرور الحالية"
                disabled={loading}
                autoComplete="current-password"
                required
              />
            </div>

            {/* New Password */}
            <div className="form-group">
              <label htmlFor="newPassword">
                كلمة المرور الجديدة *
                <span className="field-hint">6 أحرف على الأقل</span>
              </label>
              <input
                type="password"
                id="newPassword"
                name="newPassword"
                value={formData.newPassword}
                onChange={handleChange}
                placeholder="أدخل كلمة المرور الجديدة"
                disabled={loading}
                autoComplete="new-password"
                required
              />
            </div>

            {/* Confirm Password */}
            <div className="form-group">
              <label htmlFor="confirmPassword">
                تأكيد كلمة المرور الجديدة *
                <span className="field-hint">أعد إدخال كلمة المرور الجديدة</span>
              </label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder="تأكيد كلمة المرور الجديدة"
                disabled={loading}
                autoComplete="new-password"
                required
              />
            </div>

            {/* Password Strength Indicator */}
            {formData.newPassword && (
              <div className="password-strength">
                <div className="strength-label">قوة كلمة المرور:</div>
                <div className="strength-bar">
                  <div 
                    className={`strength-fill ${
                      formData.newPassword.length < 6 ? 'weak' :
                      formData.newPassword.length < 10 ? 'medium' : 'strong'
                    }`}
                    style={{
                      width: `${Math.min((formData.newPassword.length / 12) * 100, 100)}%`
                    }}
                  ></div>
                </div>
                <div className="strength-text">
                  {formData.newPassword.length < 6 && 'قصيرة جداً'}
                  {formData.newPassword.length >= 6 && formData.newPassword.length < 10 && 'متوسطة'}
                  {formData.newPassword.length >= 10 && 'قوية'}
                </div>
              </div>
            )}

            {/* Password Requirements */}
            <div className="password-requirements">
              <div className="requirement-title">متطلبات كلمة المرور:</div>
              <ul>
                <li className={formData.newPassword.length >= 6 ? 'met' : ''}>
                  ✓ 6 أحرف على الأقل
                </li>
                <li className={formData.newPassword.length >= 8 ? 'met' : ''}>
                  ✓ 8+ أحرف موصى بها
                </li>
                <li className={formData.newPassword !== formData.currentPassword && formData.newPassword.length > 0 ? 'met' : ''}>
                  ✓ مختلفة عن كلمة المرور الحالية
                </li>
              </ul>
            </div>

            {/* Submit Buttons */}
            <div className="form-actions">
              <button
                type="submit"
                className="btn-save"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-small"></span>
                    جاري التحديث...
                  </>
                ) : (
                  <>
                    <span>🔒</span>
                    تغيير كلمة المرور
                  </>
                )}
              </button>

              <Link to="/admin/dashboard" className="btn-cancel">
                إلغاء
              </Link>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default ChangePassword;